import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useHistory, Redirect, Link } from "react-router-dom";

import "../../index.scss";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";

import Sallie from "../UIComponents/Sallie";
import PillButton from "../UIComponents/PillButton";
import ComponentWrapper from "./ComponentWrapper";
import SmLinkButton from "../UIComponents/smLinkButton";
import InvitePatient from "./InvitePatient";

import Check from "../../images/checkWithinCircle.svg";

import { getUnreadMessages } from "../../api/messageRequests";

const PatientControl = ({
  user,
  patientList,
  caregiverList,
  therapistList,
  setPatient,
  setUserIdForTrackedData,
  isFreeTrial,
}) => {
  const { t } = useTranslation();

  const [unreadPatientIds, setUnreadPatientIds] = useState([]);
  const [unreadCaregiverIds, setUnreadCaregiverIds] = useState([]);
  const [unreadTherapistIds, setUnreadTherapistIds] = useState([]);

  useEffect(() => {
    if (user?.userType === "provider" || user?.userType === "Therapist") {
      getUnreadMessages()
        .then((res) => {
          const {
            patientIds = [],
            caregiverIds = [],
            therapistIds = [],
          } = res.data;
          setUnreadPatientIds(patientIds);
          setUnreadCaregiverIds(caregiverIds);
          setUnreadTherapistIds(therapistIds);
        })
        .catch((err) => console.error("Failed to fetch unread messages:", err));
    }
  }, [user]);

  const [selectedPatientTp, setSelectedPatientTp] = useState(null);
  const [selectedPatientCg, setSelectedPatientCg] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [requestInvitationVisible, setRequestInvitationVisible] =
    useState(false);

  const therapists = therapistList?.map((c) => {
    return c.caregiverName;
  });
  let uniqueTherapists = [];
  therapists &&
    therapists.forEach((c) => {
      if (!uniqueTherapists.includes(c)) {
        uniqueTherapists.push(c);
      }
    });

  const caregivers = caregiverList?.map((c) => {
    return c.caregiverName;
  });

  let uniqueCaregivers = [];
  caregivers &&
    caregivers.forEach((c) => {
      if (!uniqueCaregivers.includes(c)) {
        uniqueCaregivers.push(c);
      }
    });

  const createItemList = (res) => {
    return uniqueCaregivers.map((caregiver) => {
      const items = res.filter((item) => item.caregiverName === caregiver);
      return { caregiver, items };
    });
  };

  const createItemList2 = (res) => {
    return uniqueTherapists.map((caregiver) => {
      const items = res.filter((item) => item.caregiverName === caregiver);
      return { caregiver, items };
    });
  };

  const lastList = createItemList(caregiverList);
  const lastList2 = createItemList2(therapistList);

  const history = useHistory();

  const [submitting, setSubmitting] = useState(false);
  const [noPatientError, setNoPatientError] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  useEffect(() => {
    if (
      !(
        user.userType == "caregiver" ||
        user.userType == "provider" ||
        user.userType == "Therapist"
      )
    )
      history.push("/");
  }, []);

  const handleSubmit = (patient) => {
    if (isFreeTrial) {
      setShowUpgradeModal(true);
      return;
    }
    setSubmitting(true);
    if (!patient) {
      setNoPatientError(true);
    } else {
      setPatient(patient);
      setUserIdForTrackedData(patient.caregiverId);
      history.push("/");
    }
    setSubmitting(false);
  };

  if (!user) {
    return (
      <Redirect
        to={{
          pathname: "/signIn",
        }}
      />
    );
  }
  const patientListOptions = patientList
    ?.map((patient) => ({
      value: patient.patientId,
      label: `${patient.firstName} ${patient.lastName}${patient.externalId ? `, ID: ${patient.externalId}` : ""}${
        patient.incompletedRegister
          ? t("patientcontrol.patient_list_options.incomplete_registration")
          : ""
      } ${patient.patientStatus === "Released" ? t("patientcontrol.patient_list_options.released") : ""}`,
      hasUnread: unreadPatientIds.includes(patient.patientId),
    }))
    .sort((a, b) => a?.label.localeCompare(b?.label));

  const selectStyles = {
    option: (provided, { data, isFocused }) => {
      const baseBg = data.hasUnread ? "#3eb1a6" : provided.backgroundColor;
      const hoverBg = data.hasUnread ? "#379f95" : provided.backgroundColor;
      return {
        ...provided,
        backgroundColor: isFocused ? hoverBg : baseBg,
        color: data.hasUnread ? "white" : provided.color,
      };
    },
  };

  return (
    <div>
      <div className="d-flex align-items-center gap-3 flex-wrap">
        <Sallie
          text={
            noPatientError
              ? t("patientcontrol.sallie.no_patient_error")
              : user.userType === "provider"
                ? t("patientcontrol.sallie.provider")
                : t("patientcontrol.sallie.non_provider")
          }
        />
        {(user.userType === "provider" || user.userType === "Therapist") && (
          <Button
            variant="warning"
            className="rounded-pill text-white fw-bold ms-auto"
            onClick={() =>
              setRequestInvitationVisible(!requestInvitationVisible)
            }
          >
            {t("patientcontrol.sallie.request_invitation")}
          </Button>
        )}
      </div>
      {(user.userType === "provider" || user.userType === "Therapist") && (
        // TODO(Julian): "Request Invitation from Patient" reuses the InvitePatient
        // component from the Dashboard, but no patient has been selected yet on this
        // page (PatientControl loads before a patientId exists). For Therapist users,
        // POST /sendPatientEmail is gated by checkPermission("patientView") in
        // index.js, which appears to require a valid patientId and currently returns
        // 403 here. Provider's path (/sendPatientEmail2) has that same check
        // commented out, which is likely why it isn't hitting the same wall.
        // OPEN QUESTION for Lynne: is this button meant to invite a brand-new patient
        // (no patientId yet), or an existing tracked patient who hasn't made an
        // account? The answer determines whether we relax/bypass checkPermission for
        // this flow, or this needs a different endpoint entirely.
        <InvitePatient
          user={user}
          hideTrigger
          visible={requestInvitationVisible}
          setVisible={setRequestInvitationVisible}
          isFreeTrialInvite
        />
      )}
      <div className="w-100 p-3 mx-auto">
        <ComponentWrapper>
          <h6 className="d-block mb-4">
            {patientList && patientList.length === 0
              ? t("patientcontrol.patient_select.no_patient_error")
              : user.userType == "provider"
                ? t("patientcontrol.patient_select.provider")
                : t("patientcontrol.patient_select.non_provider")}
          </h6>
          <Row className="d-flex justify-content-center gap-8">
            {patientList && (
              <Col md={4}>
                <h5 className="mb-4 flex items-center">
                  {t("patientcontrol.patient_list.label")}
                  {unreadPatientIds.length > 0 && (
                    <span className="text-white bg-[#3eb1a6] rounded px-1.5 py-0.5 ml-2 text-xs">{t("common.new_messages")}</span>
                  )}
                </h5>
                <Select
                  options={patientListOptions}
                  value={patientListOptions.find(
                    (option) => option.value === selectedPatient
                  )}
                  placeholder={
                    t("patientcontrol.patient_list_options.select")
                  }
                  onChange={(selectedOption) => {
                    setSelectedPatient(selectedOption.value);
                    // handleSubmit(arr.items.find((patient) => patient.patientId === selectedOption.value));
                  }}
                  styles={selectStyles}
                />
                {patientList &&
                  patientList
                    .sort((a, b) => a?.firstName?.localeCompare(b?.firstName))
                    .map((patient, index) => {
                      return (
                        <Col className="d-flex justify-content-center">
                          {patient.patientId === selectedPatient && (
                            <PillButton
                              autoMargin
                              key={index}
                              onClick={() => {
                                handleSubmit(patient);
                              }}
                              variant={
                                patient.patientStatus === "Released"
                                  ? "gray"
                                  : patient === patient.patientId
                                    ? "info"
                                    : "secondary"
                              }
                            >
                              {patient === patient.patientId ? (
                                <img alt="Checked" src={Check} />
                              ) : (
                                ""
                              )}
                              {`${patient.firstName} ${patient.lastName}`}
                              {patient.externalId &&
                                `, ID: ${patient.externalId}`}
                            </PillButton>
                          )}
                        </Col>
                      );
                    })}
              </Col>
            )}

            {user.userType != "caregiver" && caregiverList && (
              <Col md={4}>
                <h5 className="mb-4">
                  {t("patientcontrol.patient_list.caregiver")}
                </h5>
                {user.userType != "caregiver" &&
                  caregiverList &&
                  lastList.map((arr, index1) => {
                    const cgId = arr.items[0]?.caregiverId;
                    const cgHasUnread = unreadCaregiverIds.includes(cgId);
                    const options = arr.items
                      .map((patient) => ({
                        value: patient.patientId,
                        label: `${patient.firstName} ${patient.lastName}
                          ${
                            patient.externalId
                              ? `, ID: ${patient.externalId}`
                              : ""
                          }${
                            patient.patientStatus === "Released"
                              ? t("patientcontrol.patient_list_options.released")
                              : ""
                          }`,
                      }))
                      .sort((a, b) => a?.label.localeCompare(b?.label));
                    return (
                      <div className="mb-4" key={index1}>
                        <h5 className="flex items-center">
                          {arr.caregiver}{" "}
                          {cgHasUnread && (
                            <span className="text-white bg-[#3eb1a6] rounded px-1.5 py-0.5 ml-2 text-xs">{t("common.new_messages")}</span>
                          )}
                        </h5>

                        <Select
                          options={options}
                          value={options.find(
                            (option) => option.value === selectedPatientCg
                          )}
                          placeholder={
                            t("patientcontrol.patient_list_options.select")
                          }
                          onChange={(selectedOption) => {
                            setSelectedPatientCg(selectedOption.value);
                            // handleSubmit(arr.items.find((patient) => patient.patientId === selectedOption.value));
                          }}
                        />
                        {arr.items
                          .sort((a, b) =>
                            a?.firstName?.localeCompare(b?.firstName)
                          )
                          .map((patient, index) => (
                            <Col key={patient.patientId}>
                              {patient.patientId === selectedPatientCg && (
                                <PillButton
                                  autoMargin
                                  key={patient.patientId}
                                  variant={
                                    patient.patientStatus === "Released"
                                      ? "gray"
                                      : patient === patient.patientId
                                        ? "info"
                                        : "secondary"
                                  }
                                  onClick={() => {
                                    handleSubmit(patient);
                                  }}
                                >
                                  {patient === patient.patientId ? (
                                    <img alt="Checked" src={Check} />
                                  ) : (
                                    ""
                                  )}
                                  {`${patient.firstName} ${patient.lastName}
                                ${
                                  patient.externalId
                                    ? `, ID: ${patient.externalId}`
                                    : ""
                                }`}
                                </PillButton>
                              )}
                            </Col>
                          ))}
                      </div>
                    );
                  })}
              </Col>
            )}

            {!["caregiver", "Therapist"].includes(user.userType) &&
              therapistList && (
                <Col md={4}>
                  <h5 className="mb-4">
                    {t("patientcontrol.patient_list.therapist")}
                  </h5>
                  {user.userType != "caregiver" &&
                    therapistList && //for provider
                    lastList2.map((arr, index1) => {
                      const tpId = arr.items[0]?.caregiverId;
                      const tpHasUnread = unreadTherapistIds.includes(tpId);
                      const options = arr.items
                        .map((patient) => ({
                          value: patient.patientId,
                          label: `${patient.firstName} ${patient.lastName}
                        ${
                          patient.externalId
                            ? `, ID: ${patient.externalId}`
                            : ""
                        }${
                          patient.patientStatus === "Released"
                            ? t("patientcontrol.patient_list_options.released")
                            : ""
                        }`,
                        }))
                        .sort((a, b) => a?.label.localeCompare(b?.label));
                      return (
                        <div key={index1} className="space-y-4">
                          <h5 className="flex items-center">
                            {arr.caregiver}{" "}
                            {tpHasUnread && (
                              <span className="text-white bg-[#3eb1a6] rounded px-1.5 py-0.5 ml-2 text-xs">{t("common.new_messages")}</span>
                            )}
                          </h5>{" "}
                          <Select
                            options={options}
                            value={options.find(
                              (option) => option.value === selectedPatientTp
                            )}
                            placeholder={
                              t("patientcontrol.patient_list_options.select")
                            }
                            onChange={(selectedOption) => {
                              setSelectedPatientTp(selectedOption.value);
                              // handleSubmit(arr.items.find((patient) => patient.patientId === selectedOption.value));
                            }}
                          />
                          {arr.items
                            .sort((a, b) =>
                              a?.firstName?.localeCompare(b?.firstName)
                            )
                            .map((patient) => (
                              <Col key={patient.patientId}>
                                {patient.patientId === selectedPatientTp && (
                                  <PillButton
                                    autoMargin
                                    variant={
                                      patient.patientStatus === "Released"
                                        ? "gray"
                                        : patient === patient.patientId
                                          ? "info"
                                          : "secondary"
                                    }
                                    onClick={() => {
                                      handleSubmit(patient);
                                    }}
                                  >
                                    {patient === patient.patientId ? (
                                      <img alt="Checked" src={Check} />
                                    ) : (
                                      ""
                                    )}
                                    {`${patient.firstName} ${patient.lastName}
                                  ${
                                    patient.externalId
                                      ? `, ID: ${patient.externalId}`
                                      : ""
                                  }`}
                                  </PillButton>
                                )}
                              </Col>
                            ))}
                        </div>
                      );
                    })}
                </Col>
              )}
          </Row>
          {(user.userType === "provider" || user.userType === "Therapist") &&
            unreadCaregiverIds.length === 0 &&
            unreadPatientIds.length === 0 &&
            unreadTherapistIds.length === 0 && (
              <div className="text-center my-4">
                <span className="inline-block bg-gray-100 text-gray-500 px-3 py-1 rounded-full text-sm">{t("common.no_new_messages")}</span>
              </div>
            )}
        </ComponentWrapper>
        {["caregiver", "Therapist"].includes(user.userType) && (
          <div className="text-base mx-2 md:text-lg md:mx-0">
            {t("patientcontrol.add_patient.0")}
            <SmLinkButton>
              <Link
                to={{
                  pathname:
                    user.userType === "caregiver"
                      ? "/RegisterPatient"
                      : "/RegisterPatientTherapist",
                  state: { fromPatientControl: true },
                }}
              >
                {t("patientcontrol.add_patient.1")}
              </Link>
            </SmLinkButton>
          </div>
        )}
      </div>
      <Modal show={showUpgradeModal} onHide={() => setShowUpgradeModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upgrade Required</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Free trial accounts don't have access to patient details. Upgrade your plan to continue.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUpgradeModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => history.push("/PaymentPage")}>
            Upgrade
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PatientControl;